<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="users">
        <v-row class="d-md-flex align-center">
            <v-col col="12" class="d-md-flex justify-md-space-between align-center">
                <h1>{{ $t('users') }}</h1>
            </v-col>
            <v-col class="filter-box d-flex justify-end" cols="12" md="6">
                <div class="btn-box">
                    <template>
                        <v-dialog
                            v-model="editUserDialog"
                            fullscreen
                            hide-overlay
                            transition="dialog-bottom-transition"
                        >
                            <v-snackbar
                                    v-model="errorsAlert"
                                    top
                                    color="#ff5252"
                                    :timeout="7000"

                            >
                                <div>
                                    <span v-for="error in errorsList" :key="error">
                                        {{ error }};
                                    </span>
                                </div>
                                <v-btn
                                    color="white"
                                    text
                                    @click="errorsAlert = false; errorsList = []"
                                >
                                    {{ $t('close') }}
                                </v-btn>
                            </v-snackbar>

                            <v-card>
                                <v-toolbar dark color="primary" class="fixed-toolbar">
                                    <v-btn icon dark @click="editUserDialog=false">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title v-if="userID !== 0 && !isReadOnly">
                                        {{ $t('user.edit') }}
                                    </v-toolbar-title>
                                    <v-toolbar-title v-else-if="userID === 0 && !isReadOnly">
                                        {{ $t('user.create_user') }}
                                    </v-toolbar-title>
                                    <v-toolbar-title v-else>{{ $t('user.user_details') }}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn dark text @click="saveUser()" :disabled="disabledSaveBtn">{{ $t('user.save') }}</v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-card-text class="details-box_card" flat>
                                    <v-container style="padding-top: 74px !important;"
                                                 :class="{'users__readonly': isReadOnly}">
                                        <v-row>
                                            <v-col cols="12">
                                                <v-autocomplete
                                                        :items="allOrganizations"
                                                        :label="$t('user.organization')"
                                                        item-text="name"
                                                        item-value="id"
                                                        required
                                                        v-model="setOrganization"
                                                        outlined
                                                        large
                                                        :error-messages="errorMessagesOrganizationField"
                                                        :search-input.sync="organizationInputText"
                                                        :disabled="isReadOnly"
                                                        :no-data-text="$t('noDataAvailable')"
                                                >
                                                    <template v-slot:item="data">
                                                        <div>
                                                            <div><b>{{data.item.name}}</b></div>
                                                            <div>
                                                                <span v-if="data.item.street">{{data.item.street}}</span>
                                                                <span v-if="data.item.postalCode">, {{data.item.postalCode}}</span>
                                                                <span v-if="data.item.place">, {{data.item.place}}</span>
                                                                <span v-if="data.item.countryCode">, {{data.item.countryCode}}</span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-autocomplete
                                                        :items="allRoleData"
                                                        :label="$t('user.role')"
                                                        item-text="name"
                                                        item-value="id"
                                                        required
                                                        v-model="selectedRole"
                                                        outlined
                                                        large
                                                        :error-messages="errorMessagesRoleField"
                                                        :search-input.sync="roleInputText"
                                                        :debounce-search="0"
                                                        :disabled="isDisabledRole()"
                                                        :no-data-text="$t('noDataAvailable')"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" v-if="firstNameShow">
                                                <v-text-field
                                                        v-model="firstNameFieldText"
                                                        :label="$t('registration.first_name')"
                                                        required
                                                        outlined
                                                        clearable
                                                        :error-messages="errorMessagesFirstNameField"
                                                        counter
                                                        maxlength="20"
                                                        :disabled="isReadOnly"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" v-if="lastNameShow">
                                                <v-text-field
                                                        v-model="lastNameFieldText"
                                                        :label="$t('registration.last_name')"
                                                        required
                                                        outlined
                                                        clearable
                                                        :error-messages="errorMessagesLastNameField"
                                                        counter
                                                        maxlength="50"
                                                        :disabled="isReadOnly"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" v-if="usernameShow">
                                                <v-text-field
                                                        v-model="usernameFieldText"
                                                        :label="$t('registration.username')"
                                                        required
                                                        outlined
                                                        clearable
                                                        :error-messages="errorMessagesUserNameField"
                                                        counter
                                                        maxlength="250"
                                                        :disabled="isReadOnly"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" v-if="passwordShow">
                                                <v-text-field
                                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                        :rules="(userID !== 0 && !isReadOnly) ? [] : [rules.required]"
                                                        :type="showPassword ? 'text' : 'password'"
                                                        name="input-password"
                                                        :label="$t('user.password')"
                                                        counter
                                                        maxlength="50"
                                                        @click:append="showPassword = !showPassword"
                                                        outlined
                                                        clearable
                                                        v-model="passwordFieldText"
                                                        :error-messages="errorMessagesPasswordField"
                                                        :disabled="isReadOnly"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                        v-model="email"
                                                        :rules="[rules.required, rules.email]"
                                                        label="E-mail"
                                                        required
                                                        outlined
                                                        clearable
                                                        counter
                                                        maxlength="255"
                                                        :error-messages="errorMessagesEmailField"
                                                        :disabled="isReadOnly"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" v-if="interfaceCodeCountryShow">
                                                <v-autocomplete
                                                        :items="interfaceCountryCode"
                                                        :label="$t('user.default_language')"
                                                        :item-text="data => data.codeName + ' - ' + data.value"
                                                        item-value="value"
                                                        required
                                                        v-model="setInterfaceCountryCode"
                                                        outlined
                                                        large
                                                        :error-messages="errorMessageInterfaceCountryCountryField"
                                                        :disabled="isReadOnly"
                                                        :no-data-text="$t('noDataAvailable')"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" v-if="transicsIDShow">
                                                <v-text-field
                                                        v-if="user.role === 'Driver User'"
                                                        v-model="transicsID"
                                                        :label="$t('user.transics_id')"
                                                        required
                                                        outlined
                                                        clearable
                                                        :error-messages="errorMessageTransicsIDField"
                                                        counter
                                                        maxlength="20"
                                                        :disabled="isReadOnly"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col v-if="defaultSignatureSignShow">
                                                <v-checkbox
                                                        v-model="defaultSignatureSign"
                                                        :label="$t('user.default_signature_sign')"
                                                        color="primary"
                                                        hide-details
                                                        :disabled="isReadOnly"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" v-show="visibleSignature">
                                                <v-file-input
                                                        :label="$t('user.input_signature_image')"
                                                        accept="image/png"
                                                        @change="onFileChange"
                                                        chips
                                                        show-size
                                                        prepend-icon="mdi-signature-image"
                                                        :error-messages="errorMessageSignatureImageField"
                                                        :disabled="isReadOnly"
                                                >
                                                </v-file-input>
                                                <v-divider></v-divider>
                                                <span v-if="this.base64 !== ''">
                                                <v-img
                                                        :src="this.base64"
                                                        aspect-ratio="1"
                                                        max-width="250"
                                                        max-height="150"
                                                ></v-img>
                                            </span>
                                                <v-divider></v-divider>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-autocomplete
                                                        :items="operationCountryCodeItems"
                                                        :label="$t('user.operation_country_code')"
                                                        :item-text="data => data.codeName + ' - ' + data.value"
                                                        item-value="value"
                                                        required
                                                        v-model="operationCountryCode"
                                                        outlined
                                                        large
                                                        :error-messages="errorMessageOperationCountryCodeField"
                                                        :disabled="isReadOnly ? isReadOnly : isDisabledAddress"
                                                        :no-data-text="$t('noDataAvailable')"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                        v-model="operationPostalCode"
                                                        :label="$t('user.operation_postal_code')"
                                                        required
                                                        outlined
                                                        clearable
                                                        :error-messages="errorMessageOperationPostalCodeField"
                                                        counter
                                                        maxlength="50"
                                                        :disabled="isReadOnly ? isReadOnly : isDisabledAddress"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                        v-model="operationPlace"
                                                        :label="$t('user.operation_place')"
                                                        required
                                                        outlined
                                                        clearable
                                                        :error-messages="errorMessageoperationPlaceField"
                                                        counter
                                                        maxlength="100"
                                                        :disabled="isReadOnly ? isReadOnly : isDisabledAddress"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field
                                                        v-model="operationStreet"
                                                        :label="$t('user.operation_street')"
                                                        required
                                                        outlined
                                                        clearable
                                                        :error-messages="errorMessageOperationStreetField"
                                                        counter
                                                        maxlength="100"
                                                        :disabled="isReadOnly ? isReadOnly : isDisabledAddress"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" v-if="userID !== 0">
                                                <v-checkbox
                                                        v-model="statusInactive"
                                                        :label="$t('user.set_inactive')"
                                                        color="primary"
                                                        hide-details
                                                        :disabled="isReadOnly"
                                                ></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>

                            <template v-slot:activator="{ on }">
                                <v-btn class="btn-two mobile-block mr-0 mr-sm-6" height="56px" text depressed v-on="on"
                                       @click.stop="openAddForm"
                                        :disabled="isCreateUserDisabled()"
                                >
                                    <v-icon medium>mdi-plus</v-icon>
                                    {{ $t('user.create_user') }}
                                </v-btn>
                            </template>
                        </v-dialog>
                    </template>

                    <v-btn class="bg-white btn-two mobile-bloc" color="#e3e9ed" height="56px" text outlined
                           @click="showSearchRow">
                        <v-icon class="ma-0" color="#4f526c">mdi-magnify</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col col="12">
                <v-expand-transition>
                    <v-row class="transition-display brd-top-vone" v-show="showSearch">
                        <v-col cols="12" md="6" lg="8">
                            <v-text-field
                                    :placeholder="$t('crm.search')"
                                    outlined
                                    hide-details
                                    v-model="searchText"
                                    background-color="#fff"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" lg="2">
                            <v-btn height="56px" class="btn-one" block text depressed @click="hideFilter">
                                <span>{{ $t('cancel') }}</span>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" md="3" lg="2">
                            <v-btn class="btn-two" color="#08a657" height="56px" block depressed dark @click="search">
                                <span>{{ $t('search') }}</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-expand-transition>
                <v-card>
                    <v-data-table
                            :headers="filteredHeaders"
                            :items="userData"
                            class="elevation-1"
                            :options.sync="options"
                            :items-per-page="options.rowsPerPageItems"
                            :server-items-length="totalItems"
                            :loading="this.$store.state.loading"
                            :footer-props="{'items-per-page-options': this.$store.state.rowsPerPageItems, 'items-per-page-text': $t('rowsPerPage')}"
                            :no-data-text="$t('noDataAvailable')"
                    >
                        <template v-slot:item.status="{ item }">
                            <span v-if="item.status === 1">{{ $t('user.active') }}</span>
                            <span style="color: red" v-if="item.status === 2">>{{ $t('user.inactive') }}</span>
                            <span v-if="item.status === 3">{{ $t('user.demands_activation') }}</span>
                            <span v-if="item.status === 4">{{ $t('user.is_blocked') }}</span>
                        </template>
                        <template v-slot:item.guid="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click.stop="showQRCode(item)"
                                        fab
                                        small
                                        color="#fff"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="#5b8ff5">
                                            mdi-qrcode
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('user.QRCodeUser') }}</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:item.signature="{ item }">
                            <span v-if="item.signature !== ''">
                                <v-img
                                        :src="`data:image/png;base64, ${item.signature}`"
                                >
                                </v-img>
                            </span>
                        </template>

                        <template v-slot:item.edit="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="editItem(item)"
                                        :disabled="isEditBtnDisabled(item)"
                                        fab
                                        small
                                        color="#fff"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="#5b8ff5">
                                            mdi-pencil-outline
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span >{{ $t('user.editUser') }}</span>
                            </v-tooltip>

                        </template>

                        <template v-slot:item.delete="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="deleteItem(item)"
                                        :disabled="isDeleteBtnDisabled(item.id)"
                                        fab
                                        small
                                        color="#fff"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="#5b8ff5">
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('user.deleteUser') }}</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:item.details="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="showDetails(item)"
                                        fab
                                        small
                                        color="#fff"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="#5b8ff5">
                                            mdi-account-details
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('user.userDetails') }}</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog
                v-model="QRCodeDialog"
                width="400"
                id="qr-code"
        >
            <v-card class="qr-code-box">
                <v-card-title
                        class="headline grey lighten-2 qr-code-box__header"
                        primary-title
                >
                    QR Code
                </v-card-title>
                <v-card-text class="justify-center align-center d-flex flex-column pt-5">
                    <qrcode :value="this.QRCode.code" :options="{ width: 200 }"></qrcode>
                    <div class="users__qr-text" v-if="QRCode.firstName || QRCode.lastName">
                        {{QRCode.firstName}} {{QRCode.lastName}}
                    </div>
                    <div class="users__qr-text" v-else-if="QRCode.userName">
                        {{QRCode.userName}}
                    </div>
                    <div class="users__qr-text" v-else-if="QRCode.email">
                        {{QRCode.email}}
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="QRCodeDialog = false"
                    >
                        {{ $t('user.close') }}
                    </v-btn>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="printQR()"
                    >
                        {{ $t('user.print') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">{{ $t('user.delete_user') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-alert type="warning">
                        {{ $t('user.delete_warning_message') }}
                    </v-alert>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="deleteDialog = false"
                    >
                        {{ $t('cancel')}}
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            text
                            @click="removeItem()"
                    >
                        {{ $t('crm.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
                v-model="snackbar.isShow"
                :timeout="3000"
        >
            {{ snackbar.text }}
            <v-btn
                    color="white"
                    text
                    @click="snackbar.isShow = false"
            >
                {{ $t('close') }}
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import {i18n} from '@/plugins/i18n'
    import config from '../config'
    import Axios from 'axios'
    import {mapActions} from 'vuex'
    import { USER_STATUSES } from '@/constants/user';

    const qs = require('querystring')

    export default {
        components: {},
        data() {
            return {
                user: {},
                errorsList: [],
                errorsAlert: false,

                options: {},
                payload: {
                    Id: 0,
                    organization: '',
                    guid: '',
                    role: '',
                    Begin: null,
                    End: null,
                    jobTitleName: '',
                    TransicsID: '',
                    Status: 0,
                    Search: '',
                    Page: 1,
                    Limit: 10,
                    OrderBy: 'Name',
                    Direction: 'asc'
                },
                QRCodeDialog: false,
                QRCode: {
                    code: '',
                    userName: '',
                    lastName: '',
                    firstName: '',
                    email: '',
                },
                showSearch: false,
                searchText: '',
                editUserDialog: false,
                userID: 0,
                dialogUser: false,
                errorMessagesRoleField: '',
                errorMessagesOrganizationField: '',
                roleInputText: '',
                organizationInputText: '',
                setRole: null,
                setOrganization: null,
                selectedRole: null,
                statusSelect: [
                    {value: 1, statusName: this.$i18n.t('user.active')},
                    {value: 2, statusName: this.$i18n.t('user.not_active')},
                    {value: 3, statusName: this.$i18n.t('user.demands_activation')},
                    {value: 4, statusName: this.$i18n.t('user.is_blocked')}
                ],
                edtit: false,
                detailsDialog: false,
                details: {
                    userId: 0,
                    name: '',
                    surname: '',
                    username: '',
                    email: '',
                    phone: '',
                    jobTitleName: '',
                    birthDate: '',
                    beginDate: '',
                    endDate: '',
                    interfaceCountryCode: '',
                    address: '',
                    role: '',
                    status: '',
                    operationCountryCode: '',
                    operationPostalCode: '',
                    operationPlace: '',
                    operationStreet: '',
                    signature: ''
                },
                firstNameFieldText: '',
                errorMessagesFirstNameField: '',
                lastNameFieldText: '',
                errorMessagesLastNameField: '',
                phoneFieldText: '',
                errorMessagesPhoneField: '',
                addressFieldText: '',
                errorMessagesAddressField: '',
                dateBirthday: '',
                menuBirthday: false,
                usernameFieldText: '',
                errorMessagesUserNameField: '',
                errorMessagesPasswordField: '',
                showPassword: false,
                rules: {
                    required: value => !!value || this.$i18n.t('user.required'),
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    },
                },
                jobTitleFieldText: '',
                errorMessagesJobTitleField: '',
                email: '',
                selectedStatus: null,
                errorMessagesStatusField: '',
                statusInputText: '',
                dateBegin: '',
                menuBegin: false,
                dateEnd: '',
                menuEnd: false,
                interfaceCountryCode: [{codeName: 'English', value: 'EN'}, {codeName: 'Netherlands', value: 'NL'}, {codeName: 'German', value: 'DE'}, {codeName: 'French', value: 'FR'}, {codeName: 'Spanish', value: 'ES'}],
                selectedInterfaceCountryCode: null,
                errorMessagesInterfaceCountryCodeField: '',
                setInterfaceCountryCode: 'EN',
                errorMessagesTransicsIDField: '',
                defaultSignatureSign: false,
                setStatus: null,
                statusInactiveShow: false,
                statusInactive: false,
                errorMessageInterfaceCountryCountryField: '',
                InterfaceCountryCodeInputText: '',
                errorMessageTransicsIDField: '',
                transicsID: '',
                errorMessageOperationCountryCodeField: '',
                operationCountryCode: '',
                errorMessageOperationPostalCodeField: '',
                operationPostalCode: '',
                errorMessageoperationPlaceField: '',
                operationPlace: '',
                errorMessageOperationStreetField: '',
                operationStreet: '',
                base64: '',
                visibleSignature: true,
                passwordFieldText: '',
                errorMessagesEmailField: '',
                errorMessageSignatureImageField: '',
                deleteDialog: false,
                firstNameShow: true,
                lastNameShow: true,
                phoneShow: true,
                addressShow: true,
                birthdateShow: true,
                usernameShow: true,
                passwordShow: true,
                jobTitleShow: true,
                dateBeginShow: true,
                dateEndShow: true,
                interfaceCodeCountryShow: true,
                transicsIDShow: true,
                defaultSignatureSignShow: true,
                operationCountryCodeItems: [],
                allOrganizations: [],
                allRoleData: [],
                errorMessageBeginDate: '',
                isReadOnly: true,
                snackbar: {
                    isShow: false,
                    text: ''
                },
                disabledSaveBtn: false,
                isDisabledAddress: true,
            }
        },
        computed: {
            headers() {
                return [
                    {text: '', value: 'details', width: '1%', align: 'left'},
                    {text: '', value: 'guid', width: '1%', align: 'left'},
                    {text: '', value: 'edit', width: '1%', align: 'left', sortable: false},
                    {text: '', value: 'delete', width: '1%', align: 'left', sortable: false},
                    {text: this.$i18n.t('user.name'), value: 'name', width: '100px', align: 'left'},
                    {text: this.$i18n.t('user.surname'), value: 'surname', width: '150px', align: 'left'},
                    /* { text: this.$i18n.t('user.phone'), value: 'phone', width: '1%', align: 'left' }, */
                    /* { text: this.$i18n.t('user.address'), value: 'address', width: '1%', align: 'left' }, */
                    {text: this.$i18n.t('user.username'), value: 'userName', width: '200px', align: 'left'},
                    {text: this.$i18n.t('user.email'), value: 'email', width: '1%', align: 'left'},
                    {
                        text: this.$i18n.t('user.organization'),
                        value: 'organization',
                        width: '1%',
                        align: 'left',
                        sortable: false
                    },
                    // { text: this.$i18n.t('user.job_title_name'), value: 'jobTitleName', width: '1%', align: 'left' },
                    {text: this.$i18n.t('user.transics_id'), value: 'transicsID', width: '150px', align: 'left'},
                    /* { text: this.$i18n.t('user.country_code'), value: 'interfaceCountryCode', width: '200px', align: 'left' }, */
                    {text: this.$i18n.t('user.role'), value: 'role', width: '1%', align: 'left', sortable: false},
                    {text: this.$i18n.t('user.status'), value: 'status', width: '100px', align: 'left'},
                    /*{ text: this.$i18n.t('user.signature'), value: 'signature', width: '1%', align: 'left' }, */
                ]
            },
            filteredHeaders() {
                return this.headers.filter(header => {
                    return !(header.value === 'transicsID' && this.user.role !== 'Driver User')
                })
            },
            totalItems() {
                return this.$store.getters.USERS_TOTAL
            },
            userData() {
                //let me = this
                let data = []

                /* eslint-disable */
                this.$store.getters.USERS_LIST.forEach(function (item) {
                    data.push({
                        id: item.id,
                        rolesId: item.rolesId,
                        organizationsId: item.organizationsId,
                        surname: item.surname,
                        name: item.name,
                        phone: item.phone,
                        address: item.address,
                        birthDate: item.birthDate,
                        userName: item.userName,
                        password: item.password,
                        guid: item.guid,
                        jobTitleName: item.jobTitleName,
                        email: item.email,
                        role: item.role,
                        status: item.status,
                        beginDate: item.beginDate,
                        endDate: item.endDate,
                        interfaceCountryCode: item.interfaceCountryCode,
                        transicsID: item.transicsID,
                        defaultSignatureSign: item.defaultSignatureSign,
                        signature: item.signature,
                        organization: item.organization,
                        operationCountryCode: item.operationCountryCode,
                        operationPostalCode: item.operationPostalCode,
                        operationPlace: item.operationPlace,
                        operationStreet: item.operationStreet,
                    })
                })

                return data
            },
        },
        created() {
            this.$vuetify.lang.current = i18n.locale;
            this.$store.state.cmrData = [];
            this.GET_COUNTRIES();
            this.getAllOrganizatios();
            this.getEmployeeList()
        },
        methods: {
            ...mapActions(['GET_COUNTRIES', 'GET_USERS', 'CREATE_USER', 'EDIT_USER', 'DELETE_USER']),

            getEmployeeList() {
                const payload = {
                    Id: localStorage.getItem('userId'),
                };
                let { user } = this;
                Axios.post(config.apiBaseUrl + 'api/employee/list', qs.stringify(payload), {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }
                )
                    .then(function ({status, data}) {
                        if (status === 200 && data.data.length === 1) {
                            user = { ...data.data[0] };
                        }
                    })
                    .catch(function (error) {
                        /* eslint-disable */
                        console.log(error)
                    })
            },
            showQRCode(item) {
                this.QRCode = {};
                this.QRCodeDialog = true;
                this.QRCode.code = item.guid;
                this.QRCode.firstName = item.name;
                this.QRCode.lastName = item.surname;
                this.QRCode.userName = item.userName;
                this.QRCode.email = item.email;
            },
            countryList() {
                let me = this
                this.$store.getters.COUNTRIES_LIST.forEach(function (item) {
                    me.operationCountryCodeItems.push({
                        value: item.code,
                        codeName: item.name
                    })
                })
            },
            editItem(item, isReadOnly = false) {
                this.countryList()
                this.editUserDialog = true
                this.isReadOnly = isReadOnly;
                this.userID = item.id
                /*let data = {
                    OrganizationsId: item.organizationsId
                }*/
                this.setOrganization = item.organizationsId
                this.selectedRole = item.rolesId
                this.firstNameFieldText = item.name
                this.lastNameFieldText = item.surname
                this.phoneFieldText = item.phone
                this.addressFieldText = item.address

                if (item.birthDate !== '' && item.birthDate !== null)
                    this.dateBirthday = item.birthDate.split('T')[0]
                else
                    this.dateBirthday = ''

                this.usernameFieldText = item.userName
                this.passwordFieldText = item.password
                this.jobTitleFieldText = item.jobTitleName
                this.email = item.email
                this.setStatus = item.status

                if (item.dateBegin !== '' && item.dateBegin !== null)
                    this.dateBegin = item.beginDate.split('T')[0]
                else
                    this.dateBegin = ''

                if (item.endDate !== '' && item.endDate !== null)
                    this.dateEnd = item.endDate.split('T')[0]
                else
                    this.dateEnd = ''

                this.setInterfaceCountryCode = item.interfaceCountryCode
                this.transicsID = item.transicsID
                this.defaultSignatureSign = item.defaultSignatureSign

                if (item.signature !== '' && item.signature !== null)
                    this.base64 = 'data:image/png;base64, ' + item.signature
                else
                    this.base64 = ''

                this.operationCountryCode = item.operationCountryCode
                this.operationPostalCode = item.operationPostalCode
                this.operationPlace = item.operationPlace
                this.operationStreet = item.operationStreet

                // if(this.userID !== 0) {
                //     this.statusInactiveShow = true
                // } else {
                //      this.statusInactiveShow = false
                // }
                this.statusInactive = item.status !== 1

                //this.getOrganizationAddress();
            },
            openAddForm() {
                this.isReadOnly = false;
                this.userID = 0
                this.setOrganization = null
                this.selectedRole = null
                this.firstNameFieldText = ''
                this.lastNameFieldText = ''
                this.phoneFieldText = ''
                this.addressFieldText = ''
                this.dateBirthday = ''
                this.usernameFieldText = ''
                this.passwordFieldText = ''
                this.jobTitleFieldText = ''
                this.email = ''
                this.setStatus = null
                this.dateBegin = ''
                this.dateEnd = ''
                this.setInterfaceCountryCode = 'EN'
                this.transicsID = ''
                this.defaultSignatureSign = false
                this.base64 = ''
                this.operationCountryCode = ''
                this.operationPostalCode = ''
                this.operationPlace = ''
                this.operationStreet = ''
                this.countryList()
                //this.getOrganizationAddress();
            },
            saveUser() {
                let data = {}
                let imgStr = ''
                let errorsCount = 0
                this.errorsList = []

                this.disabledSaveBtn = true;

                this.errorMessagesOrganizationField = ''
                this.errorMessagesRoleField = ''
                this.errorMessagesEmailField = ''
                this.errorMessageOperationCountryCodeField = ''
                this.errorMessageOperationPostalCodeField = ''
                this.errorMessageoperationPlaceField = ''
                this.errorMessageOperationStreetField = ''
                this.errorMessagesLastNameField = ''
                this.errorMessagesJobTitleField = ''
                this.errorMessagesStatusField = ''
                this.errorMessageBeginDate = ''
                this.errorMessageInterfaceCountryCountryField = ''
                this.errorMessagesPasswordField = ''
                this.errorMessagesUserNameField = ''

                if (this.organizationInputText === null) {
                    this.errorMessagesOrganizationField = this.$i18n.t('user.organization_error_msg')
                    errorsCount++
                    this.errorsList.push(this.errorMessagesOrganizationField)
                }

                if (this.roleInputText === null) {
                    this.errorMessagesRoleField = this.$i18n.t('user.role_error_msg')
                    errorsCount++
                    this.errorsList.push(this.errorMessagesRoleField)
                }


                if (this.roleInputText && (this.roleInputText.toLocaleLowerCase() === 'signing user' || this.roleInputText.toLocaleLowerCase() === 'goverment authority user')) {
                    if (this.email.length === 0) {
                        this.errorMessagesEmailField = this.$i18n.t('user.email_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessagesEmailField)
                    }

                    if (this.operationCountryCode === null) {
                        this.errorMessageOperationCountryCodeField = this.$i18n.t('user.operation_country_code_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessageOperationCountryCodeField)
                    }

                    if (this.operationPostalCode.length === 0) {
                        this.errorMessageOperationPostalCodeField = this.$i18n.t('user.operation_postal_code_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessageOperationPostalCodeField)
                    }

                    if (this.operationPlace.length === 0) {
                        this.errorMessageoperationPlaceField = this.$i18n.t('user.operation_place_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessageoperationPlaceField)
                    }

                    if (this.operationStreet.length === 0) {
                        this.errorMessageOperationStreetField = this.$i18n.t('user.operation_street_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessageOperationStreetField)
                    }

                    if (this.userID === 0) {
                        if (this.setStatus !== 3) {
                            this.errorMessagesStatusField = this.$i18n.t('user.status_error_signing_user_msg')
                            errorsCount++
                            this.errorsList.push(this.errorMessagesStatusField)
                        }
                        data.Status = 3
                    } else
                        data.Status = this.setStatus
                } else {
                    if (!this.firstNameFieldText) {
                        this.errorMessagesFirstNameField = this.$i18n.t('user.first_name_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessagesFirstNameField)
                    }

                    if (!this.lastNameFieldText) {
                        this.errorMessagesLastNameField = this.$i18n.t('user.last_name_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessagesLastNameField)
                    }

                    if (!this.usernameFieldText) {
                        this.errorMessagesUserNameField = this.$i18n.t('user.username_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessagesUserNameField)
                    }

                    if (!this.passwordFieldText && this.userID === 0 && !this.isReadOnly) {
                        this.errorMessagesPasswordField = this.$i18n.t('user.password_error_msg')
                        errorsCount++
                        this.errorsList.push(this.errorMessagesPasswordField)
                    }
                }

                if (errorsCount !== 0) {
                    this.disabledSaveBtn = false;
                    this.errorsAlert = true
                    return
                }

                data.organizationsId = this.setOrganization
                data.rolesId = this.selectedRole
                data.role = this.roleInputText
                data.Surname = this.lastNameFieldText
                data.JobTitleName = this.jobTitleFieldText
                data.Status = this.setStatus
                data.Email = this.email
                data.Name = this.firstNameFieldText
                data.Phone = this.phoneFieldText
                data.Address = this.addressFieldText
                data.BirthDate = this.dateBirthday
                data.UserName = this.usernameFieldText
                data.Password = this.passwordFieldText
                data.BeginDate = this.dateBegin
                data.EndDate = this.dateEnd
                data.InterfaceCountryCode = this.setInterfaceCountryCode
                data.TransicsID = this.transicsID
                data.DefaultSignatureSign = this.defaultSignatureSign

                if (this.base64 !== '' && this.base64 !== null) {
                    imgStr = this.base64.split('base64,')[1].trim()
                } else imgStr = ''

                data.Signature = imgStr
                if (this.userID === 0) {

                    if (this.roleInputText && (this.roleInputText.toLocaleLowerCase() === 'signing user' || this.roleInputText.toLocaleLowerCase() === 'goverment authority user')) {
                        data.Name = '';
                        data.Surname = '';
                        data.UserName = '';
                        data.Password = '';
                        data.TransicsID = '';
                        if(this.roleInputText.toLocaleLowerCase() === 'goverment authority user') {
                            data.DefaultSignatureSign = false;
                            data.Signature = '';
                        }
                    }
                    this.CREATE_USER(data)
                        .then((res) => {
                            if (typeof res.response !== 'undefined') {
                                if (res.response.status === 400 && res.response.data.indexOf('userName') !== -1) {
                                    this.errorMessagesUserNameField = this.$i18n.t('user.username_incorrect_error_msg')
                                }
                            } else {
                                this.editUserDialog = false;
                                this.isReadOnly = true;
                                this.snackbar.text = this.$i18n.t('user.created');
                                this.snackbar.isShow = true;
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                        .finally(() => setTimeout(() => this.disabledSaveBtn = false, 500))
                } else {
                    data.Id = this.userID

                    if(this.statusInactive) {
                        data.Status = 2
                    } else {
                        data.Status = 1
                    }

                    this.EDIT_USER({data, searchParams: this.payload})
                        .then((res) => {
                            if (typeof res.response !== 'undefined') {
                                if (res.response.status === 400 && res.response.data.indexOf('userName') !== -1) {
                                    this.errorMessagesUserNameField = this.$i18n.t('user.username_incorrect_error_msg')
                                }
                            } else {
                                this.editUserDialog = false
                                this.isReadOnly = true;
                                this.snackbar.text = this.$i18n.t('user.updated');
                                this.snackbar.isShow = true;
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                        .finally(() => setTimeout(() => this.disabledSaveBtn = false, 500))
                }

            },
            deleteItem(item) {
                this.deleteDialog = true
                this.userId = item.id
            },
            removeItem() {
                this.DELETE_USER({userId:this.userId, payload: this.payload})
                    .then( response => {
                        if (response.status === 200) {
                            this.snackbar.text = this.$i18n.t('user.deleted')
                            this.snackbar.isShow = true;
                        }

                    });
                this.deleteDialog = false
            },
            showSearchRow() {
                this.showSearch = true
            },
            hideFilter() {
                this.showSearch = false;
                this.searchText = '';

                this.payload = this.payloadDefault();
                this.payload.Limit = this.options.itemsPerPage;
                this.GET_USERS(this.payload);
            },
            search(e) {
                e.preventDefault()
                if (this.searchText.length > 0) {
                    this.payload = this.payloadDefault()
                    this.payload.Search = this.searchText.trim()
                    this.payload.Limit = this.options.itemsPerPage;
                    this.GET_USERS(this.payload)
                }
            },
            payloadDefault() {
                return {
                    Id: 0,
                    organization: '',
                    guid: '',
                    role: '',
                    Begin: null,
                    End: null,
                    jobTitleName: '',
                    TransicsID: '',
                    Status: 0,
                    Search: '',
                    Page: 1,
                    Limit: 10,
                    OrderBy: 'Name',
                    Direction: 'asc'
                }
            },
            printQR() {
                window.print()
            },
            showDetails(item) {
                this.editItem(item, true)
            },
            onlyNumber($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if ((keyCode < 48 || keyCode > 57) || keyCode === 46 || keyCode === 192) { // 46 is dot
                    $event.preventDefault()
                }
            },
            onFileChange(file) {
                this.base64 = ''
                if (file.type !== 'image/png') {
                    this.errorMessageSignatureImageField = this.$i18n.t('user.signature_image_type_error_msg')
                    return
                }

                if (file && file.size > 0) {
                    this.errorMessageSignatureImageField = ''
                    let reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = () => {
                        this.base64 = reader.result
                    }
                }
            },
            getOrganizationAddress() {
                if(this.setOrganization){
                    let me = this
                    Axios.post(config.apiBaseUrl + 'api/organization/list', qs.stringify({Id: this.setOrganization}), {
                            headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }
                    )
                        .then(function (response) {
                            if (response.status === 200) {
                                me.operationCountryCode = response.data.data[0].countryCode
                                me.operationPostalCode = response.data.data[0].postalCode
                                me.operationPlace = response.data.data[0].place
                                me.operationStreet = response.data.data[0].street
                            }
                        })
                        .catch(function (error) {

                        })
                }

            },
            getAllOrganizatios() {
                Axios.get(config.apiBaseUrl + 'api/organization/box-list', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then((response) => {
                        if (response.status === 200) {
                            this.allOrganizations = response.data
                        }
                    })
                    .catch(function (error) {
                        /* eslint-disable */
                        console.log(error)
                    })
            },
            getAllRoleData() {
                let $this = this;
                let payload = {OrganizationsId: this.setOrganization, Limit: 10000};
                Axios.post(config.apiBaseUrl + 'api/role/list', qs.stringify(payload), {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then( response => {
                        if (response.status === 200) {
                            $this.allRoleData = response.data.data.filter( el => {
                                switch (el.name.toLocaleLowerCase()) {
                                    case 'super admin': {
                                        return this.$isPermitted('addSuperAdminUser');
                                    }
                                    case 'super admin plus': {
                                        return this.$isPermitted('addSuperAdminUser');
                                    }
                                    case 'company admin': {
                                        return this.$isPermitted('addCompanyAdminUser');
                                    }
                                    case 'company admin plus': {
                                        return this.$isPermitted('addCompanyAdminUser');
                                    }
                                    case 'goverment authority user': {
                                        return this.$isPermitted('addGovernmentUser');
                                    }
                                    case 'driver user': {
                                        return this.$isPermitted('addDriverUser');
                                    }
                                    default: {
                                        return this.$isPermitted('addOtherUsers');
                                    }

                                }
                            })
                        }
                    })
                    .catch(function (error) {
                        /* eslint-disable */
                        console.log(error)
                    })
            },
            isDisabledRole() {
                if(this.userID !== 0) {
                    if(!this.$isPermitted('assignRole')) return true;
                }
                return this.isReadOnly;
            },
            isEditBtnDisabled(user) {
                if(user.status === USER_STATUSES.DemandsActivation || user.status === USER_STATUSES.IsBlocked) return true;
                if(!this.$isPermitted('modifyUser')) return true;
                return localStorage.getItem('userId') === String(user.id)
            },

            isDeleteBtnDisabled(userId){
                if(!this.$isPermitted('deleteUser')) return true;
                return localStorage.getItem('userId') === String(userId)
            },
            isCreateUserDisabled() {
                if (!(this.$isPermitted('addOtherUsers') || this.$isPermitted('addSuperAdminUser') || this.$isPermitted('addCompanyAdminUser') || this.$isPermitted('addGovernmentUser') || this.$isPermitted('addDriverUser'))) return true;
            }

            // end methods
        },
        watch: {
            options: {
                handler() {
                    this.$store.state.loading = true
                    this.payload.Page = this.options.page
                    this.payload.Limit = this.options.itemsPerPage

                    let sortByLength = this.options.sortBy.length
                    let sortDescLength = this.options.sortDesc.length

                    if (sortByLength > 0) {
                        this.payload.OrderBy = this.options.sortBy[0]
                    }

                    if (sortDescLength > 0) {
                        if (this.options.sortDesc[0]) {
                            this.payload.Direction = 'desc'
                        }
                    } else {
                        this.payload.Direction = 'asc'
                    }

                    this.GET_USERS(this.payload)
                },
                deep: true,
            },
            roleInputText(val) {
                this.errorMessagesRoleField = ''

                if (val && (val.toLocaleLowerCase() === 'signing user' || val.toLocaleLowerCase() === 'goverment authority user')) {
                    if (this.userID === 0) {
                        this.setStatus = 3
                    }

                    this.firstNameShow = false
                    this.lastNameShow = false
                    this.phoneShow = false
                    this.addressShow = false
                    this.birthdateShow = false
                    this.usernameShow = false
                    this.passwordShow = false
                    this.jobTitleShow = false
                    this.dateBeginShow = false
                    this.dateEndShow = false
                    this.interfaceCodeCountryShow = false
                    this.transicsIDShow = false

                    if(val.toLocaleLowerCase() === 'goverment authority user') {
                        this.visibleSignature = false
                        this.defaultSignatureSignShow = false
                    }

                } else {
                    if (this.userID === 0) {
                        this.setStatus = 1
                    }

                    this.visibleSignature = true
                    this.firstNameShow = true
                    this.lastNameShow = true
                    this.phoneShow = true
                    this.addressShow = true
                    this.birthdateShow = true
                    this.usernameShow = true
                    this.passwordShow = true
                    this.jobTitleShow = true
                    this.dateBeginShow = true
                    this.dateEndShow = true
                    this.interfaceCodeCountryShow = true
                    this.transicsIDShow = true
                    this.defaultSignatureSignShow = true

                }
            },
            organizationInputText() {
                this.errorMessagesOrganizationField = ''
                if (this.setOrganization !== null) this.getAllRoleData();
                // if (this.userID === 0) this.getOrganizationAddress()
                this.getOrganizationAddress()
            },
            email(val) {
                if (val.length > 0)
                    this.errorMessagesEmailField = ''
            },
            operationCountryCodeInputText() {
                this.errorMessageOperationCountryCodeField = ''
            },
            operationPostalCode(val) {
                if (val.length > 0)
                    this.errorMessageOperationPostalCodeField = ''
            },
            operationPlace(val) {
                if (val.length > 0) {
                    this.errorMessageoperationPlaceField = ''
                }
            },
            operationStreet(val) {
                if (val.length > 0) {
                    this.errorMessageOperationStreetField = ''
                }
            },
            lastNameFieldText(val) {
                if (val) {
                    this.errorMessagesLastNameField = ''
                }
            },
            firstNameFieldText(val) {
                if (val) {
                    this.errorMessagesFirstNameField = ''
                }
            },
            usernameFieldText(val) {
                if (val) {
                    this.errorMessagesUserNameField = ''
                }
            },
            passwordFieldText(val) {
                if (val) {
                    this.errorMessagesPasswordField = ''
                }
            },
            setStatus(val) {
                if (val === null)
                    this.errorMessagesStatusField = ''
                else if (this.roleInputText && (val !== 3 && this.roleInputText.toLocaleLowerCase() === 'signing user' && this.userID === 0))
                    this.errorMessagesStatusField = this.$i18n.t('user.status_error_signing_user_msg')
                else if (this.roleInputText && (val !== 3 && this.roleInputText.toLocaleLowerCase() === 'goverment authority user' && this.userID === 0))
                    this.errorMessagesStatusField = this.$i18n.t('user.status_error_signing_user_msg')
                else
                    this.errorMessagesStatusField = ''
            }
        }
    }
</script>
<style lang="scss">
    @media print {
        header,
        main,
        footer {
            display: none !important;
        }
        .v-dialog {
            align-self: flex-start;
            box-shadow: none !important;
            border: none !important;

            .v-card {
                &.qr-code-box {
                    box-shadow: none;

                    & > .v-card__title {
                        justify-content: center;
                    }

                    & > .v-card__text {
                        box-shadow: none;
                    }

                    .v-divider {
                        display: none;
                    }

                    .v-card__actions {
                        display: none;
                    }
                }
                & .qr-code-box__header {
                    display: none !important;
                }
            }
        }
    }
</style>
